// The name the recording device gave the file. QA checks an entry against a spreadsheet, so the
// name has to be on the page as text, and the part that matched the search has to stand out: the
// search runs on the server over every page, and without the highlight a hit is a table of players
// with nothing saying which one was found.
export default function FileName({name, highlight}) {
	if (!name) {
		return null;
	}

	const term = (highlight || "").trim();
	if (!term) {
		return <>{name}</>;
	}

	const parts = [];
	const haystack = name.toLowerCase();
	const needle = term.toLowerCase();
	let from = 0;

	while (true) {
		const at = haystack.indexOf(needle, from);
		if (at === -1) {
			break;
		}
		if (at > from) {
			parts.push(name.slice(from, at));
		}
		parts.push(<mark key={at} className={"p-0"}>{name.slice(at, at + needle.length)}</mark>);
		from = at + needle.length;
	}

	if (parts.length === 0) {
		return <>{name}</>;
	}
	parts.push(name.slice(from));

	return <>{parts}</>;
}
